import { useIsThrottleActive } from "../../hooks/useIsThrottleActive";

export const GRID_CARD_APOLLO_THROTTLE = "GRID_CARD_APOLLO";

/**
 * GRID_CARD_APOLLO: the Apollo GridCard over the legacy Redux one in pebble content. Read by PebbleContent
 * and useIsPebbleAvailable, not through Card's `throttledMigratedCards`, which pebble content never reaches.
 * Absent reads as off, like Card's `isThrottleActive`, so without throttle data the legacy card renders.
 */
export const useGridCardApolloThrottle = (): boolean => useIsThrottleActive(GRID_CARD_APOLLO_THROTTLE);
